'use strict';

exports.__esModule = true;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.defaultPromise = defaultPromise;
exports.objectMerge = objectMerge;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

/**
 * 原生ajax
 * add by zhangxiaogang 2017-09-27
 * @param {string} opt.method http连接的方式，包括POST和GET两种方式
 * @param {string} opt.url 发送请求的url
 * @param {boolean} opt.async 是否为异步请求，true为异步的，false为同步的
 * @param {object} opt.data 发送的参数，格式为对象类型
 * @param {object} opt.dataType 返回的数据格式，默认json，如果返回原生text格式请传入dataType:'text'

 * @param {function} opt.success ajax发送并接收成功调用的回调函数
 * @param {function} opt.error ajax请求失败的回调
 */
function ajax(opt) {
  opt = opt || {};
  opt.type = opt.method && opt.method.toUpperCase() || 'GET';
  opt.url = opt.url || '';
  opt.async = !!opt.async;
  opt.data = opt.data || opt.params || {};
  var xmlHttp = null;
  if (XMLHttpRequest) {
    xmlHttp = new XMLHttpRequest();
  } else {
    xmlHttp = new window.ActiveXObject('Microsoft.XMLHTTP');
  }
  var params = [];
  for (var key in opt.data) {
    params.push(key + '=' + opt.data[key]);
  }
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4) {
      if (xmlHttp.status === 200) {
        var resp = xmlHttp.responseText;
        if (opt.dataType !== 'text') {
          resp = JSON.parse(resp);
        }
        opt.success && opt.success(resp);
      } else {
        opt.error && opt.error(new Error(xmlHttp.statusText));
      }
    }
  };
  var postData = params.join('&');
  if (opt.type.toUpperCase() === 'POST') {
    xmlHttp.open(opt.type, opt.url, opt.async);
    xmlHttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8');
    if (opt.headers) {
      for (var c in opt.headers) {
        xmlHttp.setRequestHeader(c, opt.headers[c]);
      }
    }
    xmlHttp.send(postData);
  } else if (opt.type.toUpperCase() === 'GET') {
    var connector = ~opt.url.indexOf('?') ? '&' : '?';
    xmlHttp.open(opt.type, opt.url + (postData && connector) + postData, opt.async);
    xmlHttp.send(null);
  }
}

/**
 * 返回包含ajax功能的promise函数对象
 * add by zhangxiaogang 2017-09-27
 * @param {object} opt ajax请求传参
 */
function defaultPromise(opt) {
  if (Object.prototype.toString.call(opt) !== '[object Object]') return null;
  return new window.Promise(function (resolve, reject) {
    opt.success = resolve;
    opt.error = reject;
    ajax(opt);
  });
};

/**
 * 深度合并对象
 * add by zhangxiaogang 2018-05-04
 */
function objectMerge(to, from) {
  for (var key in from) {
    to[key] = to[key] && to[key].toString() === '[object Object]' ? objectMerge(to[key], from[key]) : to[key] = from[key];
  }
  return to;
}

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

// coerce truthy value to array
var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/hui/lib/utils/util.js
// module id = KzUk
// module chunks = 1